export default __webpack_public_path__ + "static/media/creative-tim-white-slim2.dbb52a5d.png";